'use client'

import { useTranslations } from 'next-intl'
import { useParams } from 'next/navigation'
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps'

import { CallDropped, LocationMark, Mail } from '@/components/icons'
import ContactCard from './ContactCard'

import type { FC } from 'react'
import type { IPreferencesData } from '@/types'

const MainOffice: FC<{ data: IPreferencesData[] }> = ({ data }) => {
  const t = useTranslations('ContactsPage')
  const params = useParams()
  const location = data
    .find(({ key }) => key === 'location')
    ?.value.split(',')
    .map(Number)

  const defaultState = {
    center: location,
    zoom: 15,
  }

  const address = data.find((val) => val.key === 'address')
  const email = data.find((val) => val.key === 'email')
  const phone = data.find((val) => val.key === 'phone')

  return (
    <section>
      <h2 className="mb-6 leading-[1] md:mb-[45px]">{t('HeadOffice')}</h2>
      <div className="flex flex-col gap-4">
        <ul className="flex flex-wrap gap-4 md:gap-6">
          {/* {contacts.map((data) => (
          ))} */}
          {email ? (
            <ContactCard
              {...{
                address: email?.value,
                icon: <Mail />,
                href: `mailto:${email?.value}`,
                name: email?.display_name,
              }}
            />
          ) : null}
          {phone ? (
            <ContactCard
              {...{
                address: phone?.value,
                icon: <CallDropped />,
                href: `tel:${phone?.value}`,
                name: phone?.display_name,
              }}
            />
          ) : null}
          {address ? (
            <ContactCard
              {...{
                address: address?.value,
                icon: <LocationMark />,
                href: `mailto:${address?.value}`,
                name: '',
              }}
            />
          ) : null}
        </ul>
        <div className="h-[250px] w-full overflow-hidden rounded-xl border border-secondary-light bg-secondary-light sm:h-[380px]">
          {location && (
            <YMaps
              preload={false}
              query={{ csp: true, lang: params.locale.includes('ru') ? 'ru_RU' : 'en_RU' }}
            >
              <Map defaultState={defaultState} className="h-full w-full">
                <Placemark
                  geometry={location}
                  properties={{
                    iconCaption: 'HPBS',
                  }}
                  options={{
                    preset: 'islands#greenPocketIcon',
                  }}
                />
              </Map>
            </YMaps>
          )}
        </div>
      </div>
    </section>
  )
}

export default MainOffice
